import { createGrpcAction, RequestActionType } from '@fullstory/redux-util';
import { DatalossRequestTypes } from './types';
import jstz from 'jstz';
import {
  DatalossInfoPublic,
  SummaryRequest,
  GetAllInTimeRangeRequest,
  UpdateDetectionEventRecordRequest,
  GetDetectionEventRecordRequest,
  CategorizeDetectionEventRecordRequest,
} from '@fullstory/proto/fs/services/dataloss';
import {
  RecordingConfigPublic,
  GenericGetRequest,
  UpdateDatalossSettingsRequest,
} from '@fullstory/proto/fs/services/ingestion-settings';
import { DeleteSegmentRequest, EraserPublic } from '@fullstory/proto/fs/services/eraser';

export const DatalossRequestActions = {
  getDetectionEventRecordsInTimeRange: (req: Omit<GetAllInTimeRangeRequest, 'timezone'>) =>
    createGrpcAction(
      {
        type: DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeRequest,
        body: { ...req, timezone: jstz.determine().name() },
        grpcFunction: DatalossInfoPublic.GetAllInTimeRange,
        force: true,
        readWrite: 'read',
      },
      DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeSuccess,
      DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeFailure,
    ),
  getDetectionEventRecord: (req: GetDetectionEventRecordRequest) =>
    createGrpcAction(
      {
        type: DatalossRequestTypes.GetDetectionEventRecordRequest,
        body: req,
        grpcFunction: DatalossInfoPublic.GetDetectionEventRecord,
        force: true,
        readWrite: 'read',
      },
      DatalossRequestTypes.GetDetectionEventRecordSuccess,
      DatalossRequestTypes.GetDetectionEventRecordFailure,
    ),
  updateDetectionEventRecord: (req: UpdateDetectionEventRecordRequest) =>
    createGrpcAction(
      {
        type: DatalossRequestTypes.UpdateDetectionEventRecordRequest,
        body: req,
        grpcFunction: DatalossInfoPublic.UpdateDetectionEventRecord,
        force: true,
        readWrite: 'write',
      },
      DatalossRequestTypes.UpdateDetectionEventRecordSuccess,
      DatalossRequestTypes.UpdateDetectionEventRecordFailure,
    ),
  categorizeDetectionEventRecord: (req: CategorizeDetectionEventRecordRequest) =>
    createGrpcAction(
      {
        type: DatalossRequestTypes.CategorizeDetectionEventRecordRequest,
        body: req,
        grpcFunction: DatalossInfoPublic.CategorizeDetectionEventRecord,
        force: true,
        readWrite: 'write',
      },
      DatalossRequestTypes.CategorizeDetectionEventRecordSuccess,
      DatalossRequestTypes.CategorizeDetectionEventRecordFailure,
    ),
  eraserDeleteSegment: (req: DeleteSegmentRequest) =>
    createGrpcAction(
      {
        type: DatalossRequestTypes.DeleteSegmentRequest,
        body: req,
        grpcFunction: EraserPublic.DeleteSegment,
        force: true,
        readWrite: 'write',
      },
      DatalossRequestTypes.DeleteSegmentSuccess,
      DatalossRequestTypes.DeleteSegmentFailure,
    ),
  fetchAllIncidents: (req: Omit<SummaryRequest, 'timezone'>) =>
    createGrpcAction(
      {
        type: DatalossRequestTypes.FetchAllIncidentsRequest,
        body: { ...req, timezone: jstz.determine().name() },
        grpcFunction: DatalossInfoPublic.Summary,
        force: true,
        readWrite: 'read',
      },
      DatalossRequestTypes.FetchAllIncidentsSuccess,
      DatalossRequestTypes.FetchAllIncidentsFailure,
    ),
  fetchAllDatalossIgnores: (req: GenericGetRequest) =>
    createGrpcAction(
      {
        type: DatalossRequestTypes.FetchAllDatalossIgnoresRequest,
        body: req,
        grpcFunction: RecordingConfigPublic.GetPrivacySettings,
        force: true,
        readWrite: 'read',
      },
      DatalossRequestTypes.FetchAllDatalossIgnoresSuccess,
      DatalossRequestTypes.FetchAllDatalossIgnoresFailure,
    ),
  updateDatalossIgnores: (req: UpdateDatalossSettingsRequest) =>
    createGrpcAction(
      {
        type: DatalossRequestTypes.UpdateDatalossIgnoresRequest,
        body: req,
        grpcFunction: RecordingConfigPublic.UpdateDatalossSettings,
        readWrite: 'write',
        force: true,
      },
      DatalossRequestTypes.UpdateDatalossIgnoresSuccess,
      DatalossRequestTypes.UpdateDatalossIgnoresFailure,
    ),
};

export type DatalossActions = RequestActionType<typeof DatalossRequestActions>;
